export default "__VITE_ASSET__TPP8gmkt__"